import React, { useState } from "react";
import Swal from "sweetalert2";
import { Container } from "react-bootstrap";
import "./DealerForm.css";

const DealerForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    area: "",
    state: "",
    pincode: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    if (!formData.name.trim()) return "Name is required";
    if (!formData.email.includes("@")) return "Valid email required";
    if (!/^[0-9]{10}$/.test(formData.mobile)) return "Valid 10-digit mobile required";
    if (!formData.area.trim()) return "Area is required";
    if (!formData.state.trim()) return "State is required";
    if (!/^[0-9]{6}$/.test(formData.pincode)) return "Valid 6-digit pincode required";
    if (!formData.message.trim()) return "Message is required";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const error = validateForm();
    if (error) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: error,
      });
      return;
    }

    try {
 const res = await fetch("/sendMail.php", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    formType: "dealer",
    ...formData
  }),
});

      const data = await res.json();

      if (data.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Form submitted successfully!",
        });

        setFormData({
          name: "",
          email: "",
          mobile: "",
          area: "",
          state: "",
          pincode: "",
          message: "",
        });

      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong, please try again!",
        });
      }

    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Server not responding!",
      });
    }
  };

  return (
    <Container fluid className="">
      <Container className="dealerform-container">

        <h2 className="dealerform-heading">
          Join Our Dealer Network
        </h2>

       <form onSubmit={handleSubmit}>

  <div className="dealerform-row">

    <div className="dealerform-field">
      <label>Full Name</label>
      <input
        type="text"
        name="name"
        placeholder="Full Name"
        value={formData.name}
        onChange={handleChange}
      />
    </div>

    <div className="dealerform-field">
      <label>Email Address</label>
      <input
        type="email"
        name="email"
        placeholder="Email Address"
        value={formData.email}
        onChange={handleChange}
      />
    </div>

  </div>

  <div className="dealerform-row">

    <div className="dealerform-field">
      <label>Mobile Number</label>
      <input
        type="text"
        name="mobile"
        placeholder="Mobile Number"
        value={formData.mobile}
        onChange={handleChange}
      />
    </div>

    <div className="dealerform-field">
      <label>Area (Sq Ft)</label>
      <input
        type="text"
        name="area"
        placeholder="Area (Sq Ft)"
        value={formData.area}
        onChange={handleChange}
      />
    </div>

  </div>

  <div className="dealerform-row">

    <div className="dealerform-field">
      <label>State</label>
      <input
        type="text"
        name="state"
        placeholder="State"
        value={formData.state}
        onChange={handleChange}
      />
    </div>

    <div className="dealerform-field">
      <label>Pincode</label>
      <input
        type="text"
        name="pincode"
        placeholder="Pincode"
        value={formData.pincode}
        onChange={handleChange}
      />
    </div>

  </div>

  <div className="dealerform-row-full dealerform-field">
    <label>Message</label>
    <textarea
      name="message"
      placeholder="Your Message"
      rows="4"
      value={formData.message}
      onChange={handleChange}
    ></textarea>
  </div>

  <div className="dealerform-submit">
    <button type="submit">Submit</button>
  </div>

</form>
      </Container>
    </Container>
  );
};

export default DealerForm;